import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import ForgetPassword from "../ForgetPassWord/index";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { AuthContext } from "../../context/Auth/AuthContext";
import Logo from "../../assets/logo.png";
import LogoWhite from "../../assets/logo_white.png";
import "./style.css";
//import { versionSystem } from "../../../package.json";
//import { nomeEmpresa } from "../../../package.json";

const versionSystem="1.8"
const nomeEmpresa="prosipe"
const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center" className="copyright" sx={{marginTop: "10px"}}>
      {"Copyright © "}
      <Link color="inherit" href="https://prosipe.com" target="blank">
       - {nomeEmpresa} - v{versionSystem} -
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

const Login = () => {
  const [user, setUser] = useState({ email: "", password: "" });
  const [openForgetPassword, setOpenForgetPassword] = useState(false);
  const { handleLogin } = useContext(AuthContext);
  const theme = useTheme();

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  return (
    <div className="login-container">
      <div className="login-bg"></div>
      <div className="login-form" style={{ backgroundColor: theme.palette.background.default }}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className="paper" style={{ backgroundColor: theme.palette.background.paper }}>
            <img className="logo" src={theme.palette.type === "dark" ? LogoWhite : Logo} alt="Logo" />
            <form className="form" noValidate onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Usuário"
                name="email"
                value={user.email}
                onChange={handleChangeInput}
                autoComplete="email"
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Senha"
                type="password"
                id="password"
                value={user.password}
                onChange={handleChangeInput}
                autoComplete="current-password"
              />
              <Button onClick={() => setOpenForgetPassword(true)} color="primary">
                Esqueci minha senha
              </Button>
              <Button type="submit" fullWidth variant="contained" color="primary" className="submit">
                Conectar-se
              </Button>
            </form>
            <Copyright />
            <Dialog open={openForgetPassword} onClose={() => setOpenForgetPassword(false)} fullWidth maxWidth="xs">
              <DialogContent>
                <ForgetPassword />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenForgetPassword(false)} color="secondary">
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Login;
